import React, { useLayoutEffect, useState, RefObject } from 'react';

type Dimen = number | undefined;

function useWindowSize(ref: RefObject<HTMLDivElement>) {
  const [size, setSize] = useState<[Dimen, Dimen]>([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([ref.current?.offsetWidth, ref.current?.offsetHeight]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  return size;
}

interface WithDimension<P> {
  (props: P): JSX.Element;
}

export default function withDimension<P>(Component: React.ComponentType<P>): WithDimension<P> {
  const wrapped = (props: P) => {
    const ref = React.useRef<HTMLDivElement>(null);
    const [width, height] = useWindowSize(ref);
    return <Component targetRef={ref} width={width} height={height} {...props} />;
  };
  return wrapped;
}
